// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";
import { Notification } from "../../models/notification.model";

class CardsService {
  private dispatch = useDispatch();

  public async getNotificationListData(query): Promise<
    | {
        notifications: Notification[];
        pagination: { pages: number; currentPage: number; total: number };
      }
    | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    try {
      const response: AxiosResponse<{
        data: {
          notifications: Notification[];
          pagination: { pages: number; currentPage: number; total: number };
        };
        message: string;
      }> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/notification${query}`
      );
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/cards`);

      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default CardsService;
